import { z } from "zod";

import { deliveryCostIssue } from "../../../../utils/delivery-cost";

type TranslateFn = (key: string, options?: Record<string, unknown>) => string;

// A counter-proposal for the demand's single delivery cost: a whole amount of 0 or more.
export const createDeliveryCostProposalSchema = (t: TranslateFn) =>
  z
    .object({
      delivery_cost: z.string().optional(),
      text: z.string().optional(),
    })
    .superRefine(
      (values, ctx) => {
        const issue = deliveryCostIssue(values.delivery_cost, t);
        if (issue) {
          ctx.addIssue({ code: "custom", path: ["delivery_cost"], message: issue });
        }
      },
      { when: () => true }
    );

export type DeliveryCostProposalValues = {
  delivery_cost: string;
  text: string;
};
